import {AclService} from './acl.service';
import {AsideService} from './aside.service';
import {AuthService} from './auth.service';
import {DictionaryService} from './dictionary.service';
import {FileService} from './file.service';
import {LoaderService} from '../modules/shared/components/loader/loader.service';
import {ModalService} from './modal.service';
import {NavRootFactory} from './nav/root.factory';
import {NavService} from './nav.service';
import {NotificationService} from './notification.service';
import {UserService} from './user.service';
import {BrokerService} from './broker.service';
import {FilterService} from './filter.service';
import {FormService} from './form.service';
import {RoleService} from './role.service';
import {VehicleService} from './vehicle.service';
import {MakeModelService} from './make-model.service';
import {AutocompleteService} from './autocomplete.service';
import {CalculationService} from './calculation.service';
import {ClauseService} from './clause.service';
import {RiskService} from './risk.service';
import {PtyService} from './pty.service';
import {SpecialDiscountService} from './special-discount.service';
import {OrderedReportService} from './ordered-report.service';
import {GeneralContractService} from './general-contract.service';
import {MessageService} from './message.service';
import {HogaService} from './hoga.service';
import {TariffBundleService} from './tariff-bundle.service';
import {TariffService} from './tariff.service';
import {PolicyService} from './policy.service';
import {GlmService} from './glm.service';
import {MatrixService} from './matrix.service';
import {UfgService} from './ufg.service';
import {BusinessDocumentService} from './business-document.service';
import {AnnexService} from './annex.service';
import {IorService} from './ior.service';
import {WhiteLabelService} from './white-label.service';
import {RegionalZoneService} from './regional-zone.service';
import {ChartService} from './chart.service';
import {ReportService} from './report.service';
import {TerytService} from './teryt.service';
import {ConfigService} from './config.service';
import {AgroReportService} from './agro-report.service';
import {ParcelService} from './agro/parcel.service';
import {BlacklistService} from './blacklist.service';
import {RenewalLogService} from './renewal-log.service';
import {GeneralContractBosCacheService} from './general-contract-bos-cache.service';
import {WsmEntityService} from './wsm-entity.service';

export const rootService = [
    AclService,
    AgroReportService,
    AnnexService,
    AsideService,
    AuthService,
    AutocompleteService,
    BlacklistService,
    BrokerService,
    BusinessDocumentService,
    CalculationService,
    ChartService,
    ClauseService,
    ConfigService,
    DictionaryService,
    FileService,
    FilterService,
    FormService,
    GeneralContractService,
    GlmService,
    HogaService,
    IorService,
    LoaderService,
    MakeModelService,
    MatrixService,
    MessageService,
    ModalService,
    NavRootFactory,
    NavService,
    NotificationService,
    OrderedReportService,
    ParcelService,
    PolicyService,
    PtyService,
    RegionalZoneService,
    RenewalLogService,
    ReportService,
    RiskService,
    RoleService,
    SpecialDiscountService,
    TariffService,
    TariffBundleService,
    TerytService,
    UfgService,
    UserService,
    VehicleService,
    WhiteLabelService,
    GeneralContractBosCacheService,
    WsmEntityService,
];
